import structuredClone from '@ungap/structured-clone';

Number.prototype.pad = function (size) {
    let s = String(this);
    while (s.length < (size || 2)) {
        s = "0" + s;
    }
    return s;
}

/**
 * Is the given value a string?
 * @param obj {*} The given value
 * @return {boolean} true if it is
 */
function isString(obj) {
    return (Object.prototype.toString.call(obj) === '[object String]');
}

/**
 * Is the given value a function?
 * @param obj {*} The given value
 * @return {boolean}
 */
function isFunction(obj) {
    return Object.prototype.toString.call(obj) === '[object Function]';
}

/**
 * Validate an email address with a regular expression
 * @param email {string}
 * @return {boolean}
 */
function validateEmail(email) {
    return !!String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}

/**
 * Given a URL return the same without the last directory
 * @param url {string}
 * @param includeParams {boolean}
 * @return {string}
 */
function removeLastDirectoryFromUrl(url, includeParams = false) {
    const split = url.split('?');
    const hasParams = split.length > 1;
    const dirPart = split[0];
    const arr = dirPart.split('/');
    if (dirPart.endsWith('/'))
        arr.pop();
    arr.pop();
    return arr.join('/') + (includeParams ? ('?' + (hasParams ? split[1] : '')) : '');
}

/**
 * Remove tags form a string
 * @param txt {string}
 * @return {string}
 */
function stripTags(txt) {
    if (!txt || txt.length === 0)
        return txt;
    return $("<div><div/>").html(txt).text();
}

function hyperlinkURLs(message) {
    message = nnTrim(message);
    if (!message) return;

    const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return message.replace(urlRegex, function (url) {
        let hyperlink = url;
        if (!hyperlink.match('^https?:\/\/')) {
            hyperlink = 'http://' + hyperlink;
        }
        return '<a href="' + hyperlink + '" target="_blank">' + url + '</a>'
    });
}

String.prototype.includesIgnoringSpecial = function (what) {
    const trimmedWat = nnTrim(what);
    if (!trimmedWat)
        return false;
    const normalize = toNormalize => toNormalize.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const normalized = normalize(String(this).toLowerCase());
    const normalizedWhat = normalize(trimmedWat.toLowerCase());
    return normalized.includes(normalizedWhat);
}

function nnTrim(obj, orElse = undefined) {
    const trimmed = obj !== undefined && obj !== null
        ? obj.toString().trim()
        : undefined;
    return trimmed && trimmed.length > 0
        ? trimmed
        : nn(null, orElse);
}

function nn(obj, orElse = undefined) {
    return obj !== undefined && obj !== null
        ? obj
        : orElse !== undefined && orElse !== null ? (isFunction(orElse) ? orElse() : orElse) : orElse;
}

String.prototype.crop = function (size) {
    return (this.length <= size
        ? this
        : this.substring(0, size - 3) + '...').toString();
}
String.prototype.cropEnd = function (size) {
    return (this.length <= size
        ? this
        : '...' + this.substring(this.length - size)).toString();
}

String.prototype.format = function () {
    const args = arguments;
    return this.replace(/\{(\d+)\}/g, function (a) {
        return args[0][parseInt(a.match(/(\d+)/g))];
    });
};

String.prototype.capitalize = function () {
    return String(this).charAt(0).toUpperCase() + String(this).slice(1);
};

String.prototype.removeCapitalization = function () {
    return String(this).charAt(0).toLowerCase() + String(this).slice(1);
};

Number.prototype.round = function (decimals = 0) {
    decimals = Math.round(decimals);
    const upDown = Math.pow(10, decimals);
    return Math.round((this + Number.EPSILON) * upDown) / upDown;
};

/**
 * Format a number
 * @param number {number} The number to format
 * @param decimals {number} integer, the nr of decimals
 * @param unit {string} The unit to append to the formatted nr (can be undefined)
 * @return {string} The formatted nr
 */
function formatNumber(number, decimals = 0, unit = undefined) {
    return isNumber(number) ?
        number.toLocaleString(undefined, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        }) + (unit ? '' + unit : '')
        : '--';
}

/**
 * String to number
 * @param str {string}
 * @return {number|*}
 */
function toNumber(str) {
    str = nnTrim(str);
    return isNumber(str) ? str : (str !== null && str !== undefined ? Number(str) : str);
}

/**
 * Is the given value a number?
 * @param value {*} The given value
 * @return {boolean} true if it is
 */
function isNumber(value) {
    return value !== null && value !== undefined && typeof value === 'number' && isFinite(value);
}

/**
 * Is the given value an integer?
 * @param value {*} The given value
 * @return {boolean} true if it is
 */
function isInteger(value) {
    return isNumber(value) && Number.isInteger(value);
}

/**
 * Is the given value a boolean?
 * @param value {*} The given value
 * @return {boolean|undefined|null} true if it is, false if isn't, undefined if undefined, null if null
 */
function isBoolean(value) {
    if (value === undefined || value === null)
        return value;
    return value === true || value === false;
}


/**
 * get a random nr from the given interval
 * @param min {number}
 * @param max {number}
 * @return {number}
 */
function getRandomNumber(min, max) {
    return Math.random() * (max - min) + min;
}

/**
 * get a random integer from the given interval
 * @param min {number} (integer)
 * @param max {number} (integer)
 * @return {number} (integer)
 */
function getRandomInteger(min, max) {
    return Math.round(Math.random() * (max - min) + min);
}

/**
 * get a random string from the given array
 * @param strings {Array<string>}
 * @return {string}
 */
function getRandomStr(strings) {
    return strings[getRandomInteger(0, strings.length - 1)];
}

function getUUID(){
    if (!crypto || !crypto.randomUUID || !isFunction(crypto.randomUUID)) { //crypto built-in library is only available when pages are considered secure

        //source: https://stackoverflow.com/a/8809472
        let d = new Date().getTime(),
            d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            let r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }
    return crypto.randomUUID();
}

async function hash(message) {
    const msgUint8 = new TextEncoder().encode(message);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", msgUint8);
    return Array.from(new Uint8Array(hashBuffer))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
}

/**
 * Clone an object or array
 * @param obj {any}
 * @return {any}
 */
function clone(obj) {
    return structuredClone(obj);
}

/**
 * Prefix a URL if needed
 * @param prefix {string}
 * @param url {string}
 */
function prefixUrl(url, prefix = tumbo.serviceUrlPrefix) {
    url = nnTrim(url);
    if (!url || url.indexOf('.') === 0)
        return url;
    prefix = nnTrim(prefix);
    if (!prefix || !url)
        return url;
    //if starts with "//", fixes the URL to start according to page location
    const fixedPrefix = (prefix.indexOf("http") === 0 ? '' : (window.location.href.indexOf('https') === 0 ? 'https://' : 'http://')) + prefix;
    return (url.indexOf('//') === 0 || url.indexOf('http://') === 0 || url.indexOf('https://') === 0
        ? url
        : fixedPrefix + (url && url.indexOf("/") === 0 ? '' : '/') + url).replace('////', '//');
}

/**
 * Download from a URL, without window navigation
 * @param url {string} The URL to download from
 * @param newTab {boolean} if true, a new tab is opened for the download
 * @param name {string} The name of the file to prefill the download dialog
 * @param onStartDownload {function} A callback to continue after this download starts. Takes the number of bytes to download
 * @param progress {function} A callback to get the already downloaded amount in bytes
 * @param onFailure {function} A callback to get an exception if there is an error
 * @param onFinish {function} A callback that will be called when the download finishes
 */
function downloadFromUrl(url, newTab = false, name = undefined, onStartDownload = undefined, progress = undefined, onFailure = undefined, onFinish = undefined) {
    let filename = undefined;
    let contentLength = undefined;
    fetch(url)
        .then(resp => {
            if (resp.status !== 200) {
                const statusText = resp.statusText;
                throw resp.status + (statusText ? (': ' + statusText) : '');
            }

            if (url.indexOf('?') < 0) {
                const split = url.split('/');
                filename = split[split.length - 1];
            }
            const contentDispositionHeader = nnTrim(resp.headers.get('Content-Disposition'));
            if (contentDispositionHeader) {
                const split = url.split(';');
                filename = nnTrim(split[split.length - 1]);
                filename = filename ? filename.split('=')[1] : filename;
            }

            contentLength = Number(resp.headers.get("content-length"));
            let loaded = 0;
            if (onStartDownload)
                onStartDownload(contentLength)
            const response = new Response(
                new ReadableStream({
                    start(controller) {
                        const reader = resp.body.getReader();
                        const read = () => {
                            reader.read().then((progressEvent) => {
                                if (progressEvent.done === true) {
                                    controller.close();
                                    return;
                                }
                                loaded += progressEvent.value.byteLength;
                                // tumbo.LOGGER.logDebug("Downloading "+nnTrim()+": "+Math.round((loaded / contentLength) * 100) + "%");
                                if (progress)
                                    progress(loaded);
                                controller.enqueue(progressEvent.value);
                                read();
                            })
                        };
                        read();
                    }
                })
            );

            if (response.status !== 200) {
                const statusText = response.statusText;
                throw response.status + (statusText ? (': ' + statusText) : '');
            }
            return response;
        })
        .catch((e) => {
            if (onFailure)
                onFailure(e);
        })
        .then(async resp => {
            if (resp) {
                const blob = await resp.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = nnTrim(name, filename);
                if (newTab)
                    a.target = '_blank'
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                if (onFinish)
                    onFinish()
            }
        });
}

/**
 * Download an image from a URL, without window navigation
 * @param url {string} The URL to download from
 * @param name {string} The name of the file to prefill the download dialog
 */
async function downloadImageFromUrl(url, name = undefined) {
    const image = await fetch(url)
    const imageBlog = await image.blob()
    const imageURL = URL.createObjectURL(imageBlog)

    const a = document.createElement('A');
    a.style = 'display:none;';
    a.href = imageURL;
    if (name)
        a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

/**
 * Download data in a separated values format
 * @param separator {string} the value separator
 * @param rows {Array.<Array>} The values rows. First row should be the column names
 * @param fileName {string} The name of the file to download
 */
function downloadSV(separator, rows, fileName) {
    downloadStringAsFile(rows.map(r => r.join(separator)).join("\n"), fileName, 'text/csv;charset=utf-8');
}

/**
 * Download a string writen to a file
 * @param str {string}
 * @param fileName {string}
 * @param mimeType {string}
 */
function downloadStringAsFile(str, fileName, mimeType) {
    const encodedUri = encodeURI("data:" + mimeType + "," + str);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", fileName);
    document.body.appendChild(link); // Required for FF
    link.click();
    link.remove();
}

/**
 * Given a sorted array of numbers, calculate a given quantile
 * @param sortedArray {Array<number>} The sorted asc array
 * @param q {number} The quantile to calculate [0..1]
 * @return {number}
 */
function quantile(sortedArray, q) {
    const pos = (sortedArray.length - 1) * q;
    const base = Math.floor(pos);
    const rest = pos - base;
    if (sortedArray[base + 1] !== undefined) {
        return sortedArray[base] + rest * (sortedArray[base + 1] - sortedArray[base]);
    } else {
        return sortedArray[base];
    }
}

/**
 * Calculate the mean of an array of numbers
 * @param array {Array<number>}
 * @return {number}
 */
function mean(array) {
    return sum(array) / array.length;
}

/**
 * Calculate the sum of an array of numbers
 * @param array {Array<number>}
 * @return {number}
 */
function sum(array) {
    return array.reduce((sum, current) => sum + current);
}

/**
 * The variance of an array of numbers
 * @param values {Array<number>}
 * @return {number}
 */
function variance(values) {
    const average = mean(values);
    const squareDiffs = values
        .map((value) => Math.pow(value - average, 2));
    return mean(squareDiffs);
}

/**
 * The standard deviation of an array of numbers
 * @param values {Array<number>}
 * @return {number}
 */
function stddev(values) {
    return Math.sqrt(variance(values));
}

/**
 * An integer array given start value and end value
 * @param from {Number} integer
 * @param to {Number} integer
 * @return {Array.<Number>}
 */
function arrayRange(from, to) {
    return [...Array(to - from + 1).keys()].map(v => v + from);
}

/**
 * The last element of an array
 * @param arr {Array.<*>}
 * @return {*|undefined}
 */
function arrayLast(arr) {
    return arr ? arr[arr.length - 1] : undefined;
}

function isVisible(element, debug=false) {
    if (!element instanceof $)
        element = $(element);
    if (!element || !element[0])
        return false;

    const rect = element[0].getBoundingClientRect();
    const rb = rect.bottom;
    const rr = rect.right;
    const rt = rect.top;
    const rl = rect.left;
    const elementOverMiddle = document.elementFromPoint((rl + rr) / 2, (rt + rb) / 2);
    if (elementOverMiddle !== element[0]) {
        let parentOver = elementOverMiddle?.parentElement;
        while (parentOver && parentOver !== element[0]) {
            parentOver = parentOver.parentElement;
        }
        if (!parentOver || parentOver !== element[0]) {
            if(debug)
                tumbo.LOGGER.logDebug("EXIT 1");
            return false;
        }
    }

    const parent = findScrollParent(element);
    if (parent === document.body) {
        const res = rt >= 0 &&
            rl >= 0 &&
            rb <= (document.body.innerHeight || document.documentElement.clientHeight) &&
            rr <= (document.body.innerWidth || document.documentElement.clientWidth);
        if(debug && !res)
            tumbo.LOGGER.logDebug("EXIT 2");
        return res;
            // && element[0].offsetParent !== null;
    }
    const scrollParentRect = parent.getBoundingClientRect();
    const st = scrollParentRect.top;
    const sl = scrollParentRect.left;
    const sb = scrollParentRect.bottom;
    const sr = scrollParentRect.right;
    const rectangleBottomIsInsideParent = rb >= st && rb <= sb;
    const rectangleTopIsInsideParent = rt <= sb && rt >= st;
    const rectangleLeftIsInsideParent = rl <= sr && rl >= sl;
    const rectangleRightIsInsideParent = rr >= sl && rr <= sr;

    const res = ((rectangleLeftIsInsideParent && (rectangleBottomIsInsideParent || rectangleTopIsInsideParent))
            ||
            (rectangleRightIsInsideParent && (rectangleBottomIsInsideParent || rectangleTopIsInsideParent)))
        // && element[0].offsetParent !== null
        && element.is(':visible');
    if(debug && !res)
        tumbo.LOGGER.logDebug("EXIT 3");
    return res;
}

function findScrollParent(element) {
    if (element instanceof $)
        element = element[0];
    if (!element) return false;

    let parent = element.parentElement;
    while (parent) {
        const overflowY = window.getComputedStyle(parent).overflowY;
        if (overflowY === 'scroll' || overflowY === 'auto') {
            return parent;
        }
        parent = parent.parentElement;
    }
    return document.body;
}

export {
    isString,
    isFunction,
    isBoolean,
    validateEmail,
    removeLastDirectoryFromUrl,
    hyperlinkURLs,
    stripTags,
    nnTrim,
    nn,
    toNumber,
    isNumber,
    isInteger,
    getRandomNumber,
    getRandomInteger,
    getRandomStr,
    getUUID,
    hash,
    formatNumber,
    clone,
    prefixUrl,
    downloadFromUrl,
    downloadImageFromUrl,
    downloadStringAsFile,
    downloadSV,
    mean,
    sum,
    quantile,
    variance,
    stddev,
    arrayRange,
    arrayLast,
    isVisible,
    findScrollParent
}